export const regionsHierarchy = [
  {
    id: 10,
    name: 'XV REGION ARICA Y PARINACOTA',
    provinces: [
      {
        id: 1,
        name: 'Arica',
        communes: [
          { id: 47, name: 'ARICA' },
          { id: 329, name: 'CAMARONES' },
        ],
      },
      {
        id: 2,
        name: 'Parinacota',
        communes: [
          { id: 230, name: 'PUTRE' },
          { id: 341, name: 'GENERAL LAGOS' },
        ],
      },
    ],
  },
  {
    id: 15,
    name: 'I REGION DE TARAPACA',
    provinces: [
      {
        id: 3,
        name: 'Iquique',
        communes: [
          { id: 139, name: 'IQUIQUE' },
          { id: 199, name: 'ALTO HOSPICIO' },
        ],
      },
      {
        id: 4,
        name: 'Tamarugal',
        communes: [
          { id: 306, name: 'POZO ALMONTE' },
          { id: 319, name: 'CAMINA' },
          { id: 334, name: 'HUARA' },
          { id: 345, name: 'COLCHANE' },
          { id: 232, name: 'PICA' },
        ],
      },
    ],
  },
  {
    id: 3,
    name: 'II REGION DE ANTOFAGASTA',
    provinces: [
      {
        id: 5,
        name: 'Antofagasta',
        communes: [
          { id: 8, name: 'ANTOFAGASTA' },
          { id: 177, name: 'MEJILLONES' },
          { id: 310, name: 'SIERRA GORDA' },
          { id: 317, name: 'OLLAGUE' },
        ],
      },
      {
        id: 6,
        name: 'El Loa',
        communes: [
          { id: 142, name: 'CALAMA' },
          { id: 299, name: 'SAN PEDRO DE ATACAMA' },
          { id: 315, name: 'TALTAL' },
        ],
      },
      {
        id: 7,
        name: 'Tocopilla',
        communes: [
          { id: 204, name: 'TOCOPILLA' },
          { id: 348, name: 'MARIA ELENA' },
        ],
      },
    ],
  },
  {
    id: 11,
    name: 'III REGION DE ATACAMA',
    provinces: [
      {
        id: 8,
        name: 'Copiapó',
        communes: [
          { id: 48, name: 'COPIAPO' },
          { id: 308, name: 'TIERRA AMARILLA' },
          { id: 256, name: 'CALDERA' },
        ],
      },
      {
        id: 9,
        name: 'Chañaral',
        communes: [
          { id: 254, name: 'CHANARAL' },
          { id: 257, name: 'DIEGO DE ALMAGRO' },
        ],
      },
      {
        id: 10,
        name: 'Huasco',
        communes: [
          { id: 214, name: 'HUASCO' },
          { id: 242, name: 'FREIRINA' },
          { id: 286, name: 'ALTO DEL CARMEN' },
          { id: 222, name: 'VALLENAR' },
        ],
      },
    ],
  },
  {
    id: 2,
    name: 'IV REGION COQUIMBO',
    provinces: [
      {
        id: 11,
        name: 'Elqui',
        communes: [
          { id: 3, name: 'COQUIMBO' },
          { id: 30, name: 'LA SERENA' },
          { id: 60, name: 'VICUNA' },
          { id: 91, name: 'ANDACOLLO' },
          { id: 338, name: 'LA HIGUERA' },
          { id: 274, name: 'PAIHUANO' },
        ],
      },
      {
        id: 12,
        name: 'Limarí',
        communes: [
          { id: 2, name: 'OVALLE' },
          { id: 154, name: 'PUNITAQUI' },
          { id: 180, name: 'MONTE PATRIA' },
          { id: 228, name: 'COMBARBALA' },
          { id: 273, name: 'RIO HURTADO' },
        ],
      },
      {
        id: 13,
        name: 'Choapa',
        communes: [
          { id: 82, name: 'SALAMANCA' },
          { id: 160, name: 'ILLAPEL' },
          { id: 163, name: 'CANELA' },
          { id: 213, name: 'LOS VILOS' },
        ],
      },
    ],
  },
  {
    id: 5,
    name: 'V REGION VALPARAISO',
    provinces: [
      {
        id: 14,
        name: 'Petorca',
        communes: [
          { id: 92, name: 'PETORCA' },
          { id: 97, name: 'CABILDO' },
          { id: 42, name: 'LA LIGUA' },
          { id: 162, name: 'ZAPALLAR' },
          { id: 210, name: 'PAPUDO' },
        ],
      },
      {
        id: 15,
        name: 'Los Andes',
        communes: [
          { id: 85, name: 'LOS ANDES' },
          { id: 178, name: 'SAN ESTEBAN' },
          { id: 106, name: 'CALLE LARGA' },
          { id: 120, name: 'RINCONADA' },
        ],
      },
      {
        id: 16,
        name: 'San Felipe de Aconcagua',
        communes: [
          { id: 36, name: 'SAN FELIPE' },
          { id: 55, name: 'PUTAENDO' },
          { id: 70, name: 'SANTA MARIA' },
          { id: 134, name: 'LLAY-LLAY' },
          { id: 148, name: 'CATEMU' },
          { id: 236, name: 'PANQUEHUE' },
        ],
      },
      {
        id: 17,
        name: 'Quillota',
        communes: [
          { id: 57, name: 'LA CALERA' },
          { id: 52, name: 'QUILLOTA' },
          { id: 54, name: 'HIJUELAS' },
          { id: 59, name: 'LA CRUZ' },
          { id: 125, name: 'NOGALES' },
        ],
      },
      {
        id: 18,
        name: 'Valparaíso',
        communes: [
          { id: 11, name: 'VALPARAISO' },
          { id: 41, name: 'VINA DEL MAR' },
          { id: 32, name: 'CASABLANCA' },
          { id: 51, name: 'PLACILLA' },
          { id: 58, name: 'QUILPUE' },
          { id: 77, name: 'VILLA ALEMANA' },
          { id: 105, name: 'CON CON' },
          { id: 183, name: 'PUCHUNCAVI' },
          { id: 193, name: 'OLMUE' },
          { id: 240, name: 'QUINTERO' },
          { id: 349, name: 'JUAN FERNANDEZ' },
        ],
      },
      {
        id: 19,
        name: 'San Antonio',
        communes: [
          { id: 13, name: 'SAN ANTONIO' },
          { id: 18, name: 'CARTAGENA' },
          { id: 62, name: 'EL QUISCO' },
          { id: 63, name: 'ALGARROBO' },
          { id: 100, name: 'EL TABO' },
          { id: 172, name: 'SANTO DOMINGO' },
        ],
      },
      {
        id: 20,
        name: 'Isla de Pascua',
        communes: [{ id: 320, name: 'ISLA DE PASCUA' }],
      },
      {
        id: 21,
        name: 'Marga Marga',
        communes: [
          { id: 15, name: 'LIMACHE' },
          { id: 77, name: 'VILLA ALEMANA' },
          { id: 58, name: 'QUILPUE' },
          { id: 193, name: 'OLMUE' },
        ],
      },
    ],
  },
  {
    id: 8,
    name: `VI REGION DEL LIBERTADOR GENERAL BERNARDO O'HIGGINS`,
    provinces: [
      {
        id: 28,
        name: 'Cachapoal',
        communes: [
          { id: 20, name: 'RANCAGUA' },
          { id: 37, name: 'REQUINOA' },
          { id: 90, name: 'OLIVAR' },
          { id: 121, name: 'CODEGUA' },
          { id: 126, name: 'MALLOA' },
          { id: 127, name: 'DONIHUE' },
          { id: 157, name: 'GRANEROS' },
          { id: 167, name: 'SAN FCO DE MOSTAZAL' },
          { id: 174, name: 'MACHALI' },
          { id: 186, name: 'RENGO' },
          { id: 231, name: 'COLTAUCO' },
          { id: 233, name: 'PEUMO' },
          { id: 272, name: 'COINCO' },
          { id: 73, name: 'SAN VICENTE T-T' },
          { id: 350, name: 'PICHIDEGUA' },
        ],
      },
      {
        id: 29,
        name: 'Colchagua',
        communes: [
          { id: 31, name: 'SANTA CRUZ' },
          { id: 33, name: 'SAN FERNANDO' },
          { id: 107, name: 'NANCAGUA' },
          { id: 118, name: 'PUMANQUE' },
          { id: 124, name: 'CHEPICA' },
          { id: 129, name: 'PERALILLO' },
          { id: 130, name: 'QUINTA TILCOCO' },
          { id: 138, name: 'SAGRADA FAMILIA' },
          { id: 165, name: 'MARCHIGUE' },
          { id: 187, name: 'PALMILLA' },
          { id: 208, name: 'CHIMBARONGO' },
          { id: 225, name: 'LAS CABRAS' },
          { id: 269, name: 'LOLOL' },
          { id: 270, name: 'LA ESTRELLA' },
          { id: 301, name: 'NAVIDAD' },
          { id: 81, name: 'PAREDONES' },
          { id: 155, name: 'PICHILEMU' },
        ],
      },
      {
        id: 30,
        name: 'Cardenal Caro',
        communes: [
          { id: 81, name: 'PAREDONES' },
          { id: 155, name: 'PICHILEMU' },
          { id: 165, name: 'MARCHIGUE' },
          { id: 270, name: 'LA ESTRELLA' },
          { id: 294, name: 'LITUECHE' },
          { id: 301, name: 'NAVIDAD' },
        ],
      },
    ],
  },
  {
    id: 6,
    name: 'VII REGION DEL MAULE',
    provinces: [
      {
        id: 31,
        name: 'Curicó',
        communes: [
          { id: 14, name: 'CURICO' },
          { id: 19, name: 'MOLINA' },
          { id: 45, name: 'ROMERAL' },
          { id: 107, name: 'NANCAGUA' },
          { id: 159, name: 'SAN RAFAEL' },
          { id: 179, name: 'VICHUQUEN' },
          { id: 198, name: 'RAUCO' },
          { id: 259, name: 'TENO' },
          { id: 312, name: 'LICANTEN' },
          { id: 269, name: 'LOLOL' },
          { id: 353, name: 'HUALANE' },
        ],
      },
      {
        id: 32,
        name: 'Talca',
        communes: [
          { id: 40, name: 'TALCA' },
          { id: 35, name: 'PENCAHUE' },
          { id: 113, name: 'CONSTITUCION' },
          { id: 136, name: 'SAN CLEMENTE' },
          { id: 144, name: 'MAULE' },
          { id: 159, name: 'SAN RAFAEL' },
          { id: 202, name: 'RIO CLARO' },
          { id: 219, name: 'EMPEDRADO' },
          { id: 279, name: 'PELARCO' },
          { id: 352, name: 'CUREPTO' },
        ],
      },
      {
        id: 33,
        name: 'Linares',
        communes: [
          { id: 64, name: 'LINARES' },
          { id: 66, name: 'SAN JAVIER' },
          { id: 53, name: 'PARRAL' },
          { id: 223, name: 'YERBAS BUENAS' },
          { id: 229, name: 'COLBUN' },
          { id: 235, name: 'RETIRO' },
          { id: 285, name: 'LONGAVI' },
          { id: 161, name: 'VILLA ALEGRE' },
        ],
      },
      {
        id: 34,
        name: 'Cauquenes',
        communes: [
          { id: 61, name: 'CAUQUENES' },
          { id: 276, name: 'CHANCO' },
          { id: 220, name: 'PELLUHUE' },
        ],
      },
    ],
  },
  {
    id: 7,
    name: 'VIII REGION DEL BIO BIO',
    provinces: [
      {
        id: 38,
        name: 'Biobío',
        communes: [
          { id: 16, name: 'LOS ANGELES' },
          { id: 71, name: 'MULCHEN' },
          { id: 131, name: 'YUMBEL' },
          { id: 197, name: 'LAJA' },
          { id: 227, name: 'QUILLECO' },
          { id: 263, name: 'NACIMIENTO' },
          { id: 307, name: 'QUILACO' },
          { id: 326, name: 'TUCAPEL' },
          { id: 327, name: 'ALTO BIO BIO' },
          { id: 344, name: 'SAN ROSENDO' },
          { id: 281, name: 'NEGRETE' },
          { id: 234, name: 'ANTUCO' },
          { id: 354, name: 'CABRERO' },
          { id: 355, name: 'SANTA BARBARA' },
        ],
      },
      {
        id: 39,
        name: 'Concepción',
        communes: [
          { id: 17, name: 'CONCEPCION' },
          { id: 38, name: 'TALCAHUANO' },
          { id: 86, name: 'SAN PEDRO DE LA PAZ' },
          { id: 146, name: 'CHIGUAYANTE' },
          { id: 149, name: 'HUALQUI' },
          { id: 176, name: 'CORONEL' },
          { id: 211, name: 'PENCO' },
          { id: 224, name: 'LOTA' },
          { id: 239, name: 'HUALPEN' },
          { id: 298, name: 'SANTA JUANA' },
          { id: 104, name: 'FLORIDA' },
          { id: 356, name: 'TOME' },
        ],
      },
      {
        id: 40,
        name: 'Arauco',
        communes: [
          { id: 153, name: 'LEBU' },
          { id: 171, name: 'CANETE' },
          { id: 188, name: 'ARAUCO' },
          { id: 258, name: 'CONTULMO' },
          { id: 266, name: 'LOS ALAMOS' },
          { id: 288, name: 'TIRUA' },
          { id: 357, name: 'CURANILAHUE' },
        ],
      },
    ],
  },
  {
    id: 13,
    name: 'IX REGION DE LA ARAUCANIA',
    provinces: [
      {
        id: 41,
        name: 'Malleco',
        communes: [
          { id: 83, name: 'ANGOL' },
          { id: 114, name: 'LONQUIMAY' },
          { id: 145, name: 'CURACAUTIN' },
          { id: 166, name: 'PUREN' },
          { id: 190, name: 'LUMACO' },
          { id: 195, name: 'COLLIPULLI' },
          { id: 241, name: 'RENAICO' },
          { id: 302, name: 'LOS SAUCES' },
          { id: 311, name: 'SAN FABIAN' },
          { id: 339, name: 'ERCILLA' },
          { id: 358, name: 'TRAIGUEN' },
        ],
      },
      {
        id: 42,
        name: 'Cautín',
        communes: [
          { id: 56, name: 'TEMUCO' },
          { id: 74, name: 'VILLARRICA' },
          { id: 75, name: 'FREIRE' },
          { id: 80, name: 'PADRE LAS CASAS' },
          { id: 99, name: 'VICTORIA' },
          { id: 103, name: 'TEODORO SCHMIDT' },
          { id: 114, name: 'LONQUIMAY' },
          { id: 128, name: 'LONCOCHE' },
          { id: 156, name: 'VILCUN' },
          { id: 168, name: 'CARAHUE' },
          { id: 181, name: 'LAUTARO' },
          { id: 189, name: 'NUEVA IMPERIAL' },
          { id: 217, name: 'PANGUIPULLI' },
          { id: 246, name: 'CUNCO' },
          { id: 271, name: 'PITRUFQUEN' },
          { id: 275, name: 'GORBEA' },
          { id: 303, name: 'TOLTEN' },
          { id: 324, name: 'SAAVEDRA' },
          { id: 333, name: 'MELIPEUCO' },
          { id: 335, name: 'CURARREHUE' },
          { id: 331, name: 'CHOLCHOL' },
          { id: 359, name: 'GALVARINO' },
          { id: 360, name: 'PERQUENCO' },
          { id: 361, name: 'PUCON' },
        ],
      },
    ],
  },
  {
    id: 12,
    name: 'XIV REGION DE LOS RIOS',
    provinces: [
      {
        id: 43,
        name: 'Valdivia',
        communes: [
          { id: 111, name: 'VALDIVIA' },
          { id: 117, name: 'FUTRONO' },
          { id: 212, name: 'LOS LAGOS' },
          { id: 217, name: 'PANGUIPULLI' },
          { id: 282, name: 'LANCO' },
          { id: 283, name: 'PAILLACO' },
          { id: 291, name: 'MAFIL' },
          { id: 321, name: 'CORRAL' },
          { id: 369, name: 'MARIQUINA' },
        ],
      },
      {
        id: 44,
        name: 'Ranco',
        communes: [
          { id: 49, name: 'LA UNION' },
          { id: 110, name: 'RIO BUENO' },
          { id: 248, name: 'PUYEHUE' },
          { id: 249, name: 'LAGO RANCO' },
        ],
      },
    ],
  },
  {
    id: 4,
    name: 'X REGION LOS LAGOS',
    provinces: [
      {
        id: 45,
        name: 'Osorno',
        communes: [
          { id: 10, name: 'OSORNO' },
          { id: 143, name: 'RIO NEGRO' },
          { id: 191, name: 'LOS MUERMOS' },
          { id: 201, name: 'SAN PABLO' },
          { id: 247, name: 'PURRANQUE' },
          { id: 252, name: 'PUERTO OCTAY' },
          { id: 267, name: 'FRESIA' },
          { id: 293, name: 'SAN JUAN DE LA COSTA' },
        ],
      },
      {
        id: 46,
        name: 'Llanquihue',
        communes: [
          { id: 65, name: 'PUERTO MONTT' },
          { id: 133, name: 'PUERTO VARAS' },
          { id: 255, name: 'LLANQUIHUE' },
          { id: 290, name: 'MAULLIN' },
          { id: 295, name: 'CALBUCO' },
          { id: 300, name: 'HUALAIHUE' },
          { id: 296, name: 'COCHAMO' },
          { id: 362, name: 'FRUTILLAR' },
        ],
      },
      {
        id: 47,
        name: 'Chiloe',
        communes: [
          { id: 175, name: 'ANCUD' },
          { id: 150, name: 'CASTRO' },
          { id: 175, name: 'ANCUD' },
          { id: 194, name: 'CHONCHI' },
          { id: 253, name: 'DALCAHUE' },
          { id: 305, name: 'PUQUELDON' },
          { id: 309, name: 'QUELLON' },
          { id: 313, name: 'QUINCHAO' },
          { id: 328, name: 'QUEILEN' },
          { id: 330, name: 'QUEMCHI' },
          { id: 336, name: 'CURACO DE VELEZ' },
        ],
      },
      {
        id: 48,
        name: 'Palena',
        communes: [
          { id: 169, name: 'CHAITEN' },
          { id: 250, name: 'FUTALEUFU' },
          { id: 325, name: 'PALENA' },
        ],
      },
    ],
  },
  {
    id: 16,
    name: 'XI REGION AYSEN DEL GENERAL CARLOS IBAÑEZ DEL CAMPO',
    provinces: [
      {
        id: 49,
        name: 'Coyhaique',
        communes: [
          { id: 216, name: 'COYHAIQUE' },
          { id: 342, name: 'LAGO VERDE' },
        ],
      },
      {
        id: 50,
        name: 'Aysén',
        communes: [
          { id: 280, name: 'AYSEN' },
          { id: 237, name: 'CISNES' },
          { id: 343, name: 'GUAITECAS' },
        ],
      },
      {
        id: 51,
        name: 'General Carrera',
        communes: [
          { id: 322, name: 'CHILE CHICO' },
          { id: 337, name: 'OHIGGINS' },
          { id: 340, name: 'TORTEL' },
        ],
      },
      {
        id: 52,
        name: 'General Prat',
        communes: [
          { id: 206, name: 'COCHRANE' },
          { id: 262, name: 'RIO IBANEZ' },
        ],
      },
    ],
  },
  {
    id: 14,
    name: 'XII REGION DE MAGALLANES Y LA ANTARTICA CHILENA',
    provinces: [
      {
        id: 53,
        name: 'Última Esperanza',
        communes: [
          { id: 185, name: 'PUERTO NATALES' },
          { id: 292, name: 'TORRES DE PAINE' },
        ],
      },
      {
        id: 54,
        name: 'Magallanes',
        communes: [
          { id: 79, name: 'PUNTA ARENAS' },
          { id: 297, name: 'RIO VERDE' },
          { id: 264, name: 'SAN GREGORIO' },
          { id: 318, name: 'LAGUNA BLANCA' },
        ],
      },
      {
        id: 55,
        name: 'Tierra del Fuego',
        communes: [
          { id: 215, name: 'PORVENIR' },
          { id: 268, name: 'TIMAUKEL' },
          { id: 346, name: 'ANTARTIDA' },
          { id: 363, name: 'PRIMAVERA' },
        ],
      },
      {
        id: 56,
        name: 'Antártica Chilena',
        communes: [{ id: 323, name: 'CABO DE HORNOS' }],
      },
    ],
  },
  {
    id: 9,
    name: 'XVI REGION DE ÑUBLE',
    provinces: [
      {
        id: 35,
        name: 'Diguillín',
        communes: [
          { id: 44, name: 'CHILLAN' },
          { id: 244, name: 'CHILLAN VIEJO' },
          { id: 158, name: 'YUNGAY' },
          { id: 170, name: 'COIHUECO' },
          { id: 200, name: 'RANQUIL' },
          { id: 261, name: 'BULNES' },
          { id: 265, name: 'PEMUCO' },
          { id: 289, name: 'PINTO' },
          { id: 311, name: 'SAN FABIAN' },
        ],
      },
      {
        id: 36,
        name: 'Itata',
        communes: [
          { id: 203, name: 'QUILLON' },
          { id: 251, name: 'COBQUECURA' },
          { id: 260, name: 'COELEMU' },
          { id: 278, name: 'NINHUE' },
          { id: 284, name: 'PORTEZUELO' },
          { id: 316, name: 'TREHUACO' },
        ],
      },
      {
        id: 37,
        name: 'Punilla',
        communes: [
          { id: 135, name: 'SAN CARLOS' },
          { id: 141, name: 'SAN NICOLAS' },
          { id: 170, name: 'COIHUECO' },
          { id: 192, name: 'QUIRIHUE' },
          { id: 370, name: 'EL CARMEN' },
          { id: 371, name: 'NIQUEN' },
          { id: 372, name: 'SAN IGNACIO' },
        ],
      },
    ],
  },
  {
    id: 1,
    name: 'XIII REGION METROPOLITANA',
    provinces: [
      {
        id: 22,
        name: 'Chacabuco',
        communes: [
          { id: 25, name: 'COLINA' },
          { id: 109, name: 'LAMPA' },
          { id: 196, name: 'TIL-TIL' },
        ],
      },
      {
        id: 23,
        name: 'Santiago',
        communes: [
          { id: 5, name: 'SANTIAGO' },
          { id: 6, name: 'PROVIDENCIA' },
          { id: 12, name: 'NUNOA' },
          { id: 21, name: 'CONCHALI' },
          { id: 24, name: 'PENALOLEN' },
          { id: 27, name: 'MACUL' },
          { id: 34, name: 'LA FLORIDA' },
          { id: 39, name: 'RECOLETA' },
          { id: 43, name: 'LO BARNECHEA' },
          { id: 67, name: 'HUECHURABA' },
          { id: 69, name: 'SAN JOAQUIN' },
          { id: 87, name: 'LA REINA' },
          { id: 88, name: 'CERRILLOS' },
          { id: 93, name: 'PUDAHUEL' },
          { id: 94, name: 'CERRO NAVIA' },
          { id: 95, name: 'LA GRANJA' },
          { id: 98, name: 'EST CENTRAL' },
          { id: 101, name: 'RENCA' },
          { id: 102, name: 'LO PRADO' },
          { id: 147, name: 'LA PINTANA' },
          { id: 151, name: 'LO ESPEJO' },
          { id: 209, name: 'QUILICURA' },
          { id: 4, name: 'SAN MIGUEL' },
          { id: 9, name: 'LA CISTERNA' },
          { id: 22, name: 'SAN BERNARDO' },
          { id: 76, name: 'VITACURA' },
          { id: 78, name: 'PUENTE ALTO' },
          { id: 115, name: 'CALERA DE TANGO' },
          { id: 122, name: 'PAINE' },
          { id: 123, name: 'PADRE HURTADO' },
          { id: 132, name: 'MAIPU' },
          { id: 173, name: 'EL MONTE' },
          { id: 207, name: 'SAN JOSE MAIPO' },
          { id: 218, name: 'ISLA DE MAIPO' },
          { id: 347, name: 'PEDRO AGUIRRE CERDA' },
          { id: 23, name: 'PIRQUE' },
          { id: 46, name: 'PENAFLOR' },
          { id: 140, name: 'CURACAVI' },
          { id: 119, name: 'ALHUE' },
          { id: 26, name: 'MELIPILLA' },
          { id: 50, name: 'TALAGANTE' },
          { id: 364, name: 'EL BOSQUE' },
          { id: 365, name: 'INDEPENDENCIA' },
          { id: 366, name: 'LAS CONDES' },
          { id: 367, name: 'QUINTA NORMAL' },
          { id: 368, name: 'SAN RAMON' },
        ],
      },
      {
        id: 24,
        name: 'Cordillera',
        communes: [
          { id: 78, name: 'PUENTE ALTO' },
          { id: 23, name: 'PIRQUE' },
          { id: 207, name: 'SAN JOSE MAIPO' },
        ],
      },
      {
        id: 25,
        name: 'Maipo',
        communes: [
          { id: 68, name: 'BUIN' },
          { id: 115, name: 'CALERA DE TANGO' },
          { id: 122, name: 'PAINE' },
          { id: 22, name: 'SAN BERNARDO' },
        ],
      },
      {
        id: 26,
        name: 'Melipilla',
        communes: [
          { id: 119, name: 'ALHUE' },
          { id: 26, name: 'MELIPILLA' },
          { id: 140, name: 'CURACAVI' },
          { id: 164, name: 'SAN PEDRO DE MELIPILLA' },
          { id: 182, name: 'MARIA PINTO' },
        ],
      },
      {
        id: 27,
        name: 'Talagante',
        communes: [
          { id: 173, name: 'EL MONTE' },
          { id: 46, name: 'PENAFLOR' },
          { id: 123, name: 'PADRE HURTADO' },
          { id: 218, name: 'ISLA DE MAIPO' },
          { id: 50, name: 'TALAGANTE' },
        ],
      },
    ],
  },
  {
    id: 17,
    name: 'SIN INFORMACIÓN',
    provinces: [
      {
        id: 0,
        name: 'SIN PROVINCIA',
        communes: [{ id: 314, name: 'SIN COMUNA' }],
      },
    ],
  },
];
